import React, { Component } from 'react';
import {
  AppBar,
  CircularProgress,
  Toolbar,
  Typography,
} from '@material-ui/core';

export class LoadingScreen extends Component {
  render() {
    return (
      <div>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" color="inherit">
              DeWaste Dashboard
            </Typography>
          </Toolbar>
        </AppBar>
        <CircularProgress
          style={{ display: 'block', margin: 'auto', marginTop: '20%' }}
        />
      </div>
    );
  }
}
